import { ErrorHandler, Input, OnChanges, OnInit } from '@angular/core';
import { DetailBase } from '~/app/open-age/core/structures';
import { Message } from '../models';
import { MessageService } from '../services';

export class MessageDetailBaseComponent extends DetailBase<Message> implements OnChanges {

  @Input()
  code: string;
  constructor(
    api: MessageService,
    errorHandler: ErrorHandler
  ) {
    super({ api, errorHandler });
  }

  ngOnChanges(): void {
    this.get(this.code);
  }
}
